import React from 'react';
import {Table} from "../ui/Table";
import {makeStyles} from "@mui/styles";
import {IntegrationEventListItem} from "./IntegrationEventListItem";

const useStyles = makeStyles({
    root: {
        background: "#fff",
        marginTop: 16
    }
});

interface Props {
    readonly data: any[]
    readonly isTrigger?: boolean
}

export function IntegrationEventsList({data, isTrigger}: Props) {
    const classes = useStyles();


    return (
        <div className={classes.root}>
            <Table>
                <thead>
                <tr>
                    <th>Label</th>
                    <th>Key</th>
                    <th>Description</th>
                </tr>
                </thead>
                <tbody>
                {data?.map(item => (
                   <IntegrationEventListItem item={item} key={item.id} isTrigger={isTrigger} />
                ))}
                </tbody>
            </Table>
        </div>
    );
}

